// const apptype = 'parking';
const apptype = 'simasganteng';

// const baseUrlApi = 'http://localhost:3100/api/v1';
// const baseUrlApi = 'http://192.168.1.109:3100/api/v1';
// const baseUrlApi = 'http://192.168.1.4:3100/api/v1';
// const baseUrlApi = 'https://api-simasganteng-tuban.pohonmedia.com/api/v1';
const baseUrlApi = 'https://apisimasganteng.tubankab.go.id/api/v1';

const exportVariable = {
    apptype,
    baseUrlApi
}

export default exportVariable;